module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/2023/area-icon2-3cd996ae0a572b8bc74b953de262d3c5.svg&quot;;"